/****************************************************
 * Module Name:  ForceMediaTransfer.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import Constants from "../../utility/constants";
import { DataGridPro, GridToolbarExport, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarFilterButton, GridToolbarQuickFilter } from "@mui/x-data-grid-pro";
import { Box, Button, Checkbox, Container, TextField, Tooltip, Typography } from "@mui/material";
import Select from "react-select";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import renderCellExpand from "../common/dataGridCellExpand";
import Utility from "../../utility/utility";
import { useEffect } from "react";
import StoneDetailModal from "../common/stoneDetailModal";
import { styled } from "@mui/material/styles";
import NoPermission from "../common/noPermission";
import CommonStoneSelection from "../common/commonStoneSelection";
import TabMenuSnackbar from "../common/tabMenuSnackbar";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import MediaTransferProxy from "../../utility/proxy/manager/mediaTransferProxy";
import { LoadingButton } from "@mui/lab";
import logo from '../../images/pansuriya.jpg'
import { Form, Modal } from "react-bootstrap";
import SaveIcon from '@mui/icons-material/Save';
import VideoLibraryTwoToneIcon from '@mui/icons-material/VideoLibraryTwoTone';
import StoneMediaModal from "../common/stoneMediaModal";
import PageTitle from "../common/pageTitle";
import StonestatusProxy from "../../utility/proxy/manager/stonestatusProxy";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";

const StyledDataGrid = styled(DataGridPro)(({ theme }) => ({
    "& .super-app-theme--NEW": {
        backgroundColor: "#F9F08D",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#F9F08D",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--LAB": {
        backgroundColor: "#7EAEEE",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#7EAEEE",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
            color: "black",
        },
    },
    "& .super-app-theme--RE-LAB": {
        backgroundColor: "#FCCD91",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#FCCD91",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--RE-CHECK": {
        backgroundColor: "#FFFFCC",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#FFFFCC",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--RE-CHECK_SENT": {
        backgroundColor: "#B8ACF6",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#B8ACF6",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--RE-CHECK_DONE": {
        backgroundColor: "#388BFF",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#388BFF",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--MIX": {
        backgroundColor: "#E0E88C",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#E0E88C",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--AVAILABLE_APPROVAL_PENDING": {
        backgroundColor: "#FBDEDE",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#FBDEDE",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--AVAILABLE": {
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--HOLD": {
        backgroundColor: "#B6B9D6",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#B6B9D6",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--MEMO_OUT": {
        backgroundColor: "#CAF7F6",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#CAF7F6",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--LOCATION_SENT": {
        backgroundColor: "#FEBD7D",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#FEBD7D",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    '& .MuiDataGrid-columnHeader': {
        color: '#fff',
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        backgroundColor: 'grey',
    },
    "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
        py: "8px",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
    },
    "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
        py: "15px",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
    },
    "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
        py: "22px",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
    },

}));

export default function ForceMediaTransfer() {
    const [stockData, setStockData] = useState([]);
    const [stockLoader, setStockLoader] = useState(false);
    const [selectionModel, setSelectionModel] = useState([]);

    const [stoneId, setStoneId] = useState("");
    const [showStoneDetailModal, setShowStoneDetailModal] = useState(false);
    const [successSnackbar, setSuccessSnackbar] = useState(false);
    const [errorMessage, setErrorMessage] = useState(false);
    const [errorSnackbar, setErrorSnackbar] = useState(false);
    const [sortModel, setSortModel] = React.useState([]);

    const [filterValues, setFilterValues] = useState({});
    const statusOptions = [
        { label: "-- ANY --", value: "*" },
        { label: "NEW", value: "NEW" },
        { label: "IN_PROGRESS", value: "IN_PROGRESS" },
        { label: "PROCESSED", value: "PROCESSED" },
        { label: "FAILED", value: "FAILED" },
    ];
    const [status, setStatus] = useState([statusOptions[4]]);
    const [stoneStatusOptions, setStoneStatusOptions] = useState([]);
    const [stoneStatus, setStoneStatus] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [loadingButton, setLoadingButton] = useState(false);
    const [stoneIds, setStoneIds] = useState("");
    const [stoneMediaURL, setStoneMediaURL] = useState([]);
    const [showStoneMediaModal, setShowStoneMediaModal] = useState(false);
    const [force, setForce] = useState(false);

    // eslint-disable-next-line
    const [mediaTransferPermission, setMediaTransferPermission] = useState(
        Constants.USER_PERMISSION.filter(
            (iPermission) =>
                iPermission.permissionid === Constants.PERMISSIONS.OPERATION_MEDIA_TRANSFER
        )
    );
    const [columns, setColumns] = useState([]);

    useEffect(() => {
        PageTitle("OPERATION_MEDIA_TRANSFER");
        getAllStoneStatusData();
    }, []);

    const getAllStoneStatusData = () => {
        StonestatusProxy.GetAllStonestatusMini((response) =>
            setAllStoneStatusData(response)
        );
    };

    const setAllStoneStatusData = (response) => {
        let optionsArray = [];
        let selectedOption = [];
        optionsArray.push({ value: "*", label: "-- ANY --" });
        response.map((data) => {
            let option = { value: data.status, label: data.status };
            optionsArray.push(option);

            return true;
        });

        optionsArray.map((data) => {

            if (data.value === "AVAILABLE" || data.value === "MEMO_OUT" || data.value === "SELL" || data.value === "LAB" || data.value === "HOLD"
                || data.value === "RE-LAB" || data.value === "AVAILABLE_APPROVAL_PENDING")
                selectedOption.push(data);

            return true;
        });

        setStoneStatusOptions(optionsArray);
        setStoneStatus(selectedOption);
    };

    const fullOptionToValue = (selectedData, optionArr) => {
        if (selectedData.value === "*") {
            return [];
        }
        return Utility.GetValueArrayWithStarReplace(
            selectedData,
            Utility.GetValueArrayWithoutStar(optionArr)
        );
    };

    const handleSearch = () => {

        setStockLoader(true);
        let data = {
            status: fullOptionToValue(status, statusOptions),
            stonestatus: fullOptionToValue(stoneStatus, stoneStatusOptions),
        }

        MediaTransferProxy.GetMediaTransferStoneWithStatus(data, (response) => {
            if (response) {
                const uniqueFilterValues = {
                    status: Utility.getDistinctOptions(response, "status"),
                    stonestatus: Utility.getDistinctOptions(response, "stonestatus"),
                    shape: Utility.getDistinctOptions(response, "shape"),
                    lab: Utility.getDistinctOptions(response, "lab"),
                    color: Utility.getDistinctOptions(response, "color"),
                    clarity: Utility.getDistinctOptions(response, "clarity"),
                    imgstatus: Utility.getDistinctOptions(response, "imgstatus"),
                    vidstatus: Utility.getDistinctOptions(response, "vidstatus"),
                    certstatus: Utility.getDistinctOptions(response, "certstatus"),
                    mp4status: Utility.getDistinctOptions(response, "mp4status"),
                    jsonstatus: Utility.getDistinctOptions(response, "jsonstatus"),
                };
                setFilterValues(uniqueFilterValues);
                setStockData(response);
                setStockLoader(false);
            } else {
                setStockLoader(false);
                setErrorSnackbar(true);
            }
        })
    };

    useEffect(() => {
        if (selectionModel.length > 0)
            setStoneIds(selectionModel.join(", ") + (","));
    }, [selectionModel]);

    useEffect(() => {
        const localStorageKey = `${window.location.pathname.split('/').pop()}_ColumnOrder`;
        const savedColumnOrder = JSON.parse(localStorage.getItem(localStorageKey));

        const originalColumns = initialColumns();
        Utility.applySavedColumnOrder(savedColumnOrder, originalColumns, setColumns);
    }, [stockData]);

    const handleClose = () => {
        setShowModal(false);
        setShowStoneDetailModal(false);
    };

    const handleStoneDetailModal = (params) => {
        setStoneId(params.value);
        setShowStoneDetailModal(true);
    };

    const handleSelection = (data) => {
        const [tempStockData, tempSelectionModel] = Utility.handleSelection(data, stockData, selectionModel);

        setStockData(tempStockData);
        setSelectionModel(tempSelectionModel);
    }

    const saveHandler = () => {
        setLoadingButton(true);
        MediaTransferProxy.AddStonesToMediaTransfer(stoneIds.split(',').filter(item => item !== '').map(Number), force, (response) => {
            if (response) {
                if (response.status === "Success")
                    setSuccessSnackbar(true);
                else {
                    setErrorSnackbar(true);
                    setErrorMessage(response.errorMessage + ". Please check the stones detail.");
                }
                handleSearch();
                setShowModal(false);
                setLoadingButton(false);
            } else {
                setErrorMessage("");
                setErrorSnackbar(true);
            }
        });
    }

    const initialColumns = () => [
        {
            field: "stoneid",
            headerName: "STONE ID",
            headerAlign: "center",
            align: "center",
            width: 90,
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: (params) => Utility.NeedToShowStoneDetailModal() ? (
                <Button
                    sx={{
                        textDecorationLine: "underline",
                        color: 'black'
                    }}
                    onClick={() => handleStoneDetailModal(params)}
                >
                    {params.value}
                </Button>
            ) : (
                <div>{params.value}</div>
            ),
        },
        {
            field: "stonestatus",
            headerName: "STONE STATUS",
            headerAlign: "center",
            align: "center",
            width: 110,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.stonestatus : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        {
            field: "stonetype",
            headerName: "STONETYPE",
            headerAlign: "center",
            align: "center",
            width: 90,
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.stonetype.map(option => option.fullname),
            filterOperators: Utility.combinedFilters(),
            valueGetter: (params) => Constants.STONE_TYPE[params.value],
            renderCell: (params) => Constants.STONE_TYPE[params.value],
        },
        {
            field: "shape",
            headerName: "SHAPE",
            headerAlign: "center",
            align: "center",
            width: 113,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.shape : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        {
            field: "lab",
            headerName: "LAB",
            headerAlign: "center",
            align: "center",
            width: 80,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.lab : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        {
            field: "color",
            headerName: "COLOR",
            headerAlign: "center",
            align: "center",
            width: 80,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.color : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        {
            field: "clarity",
            headerName: "CLARITY",
            headerAlign: "center",
            align: "center",
            width: 80,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.clarity : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        {
            field: "size",
            headerName: "SIZE",
            headerAlign: "center",
            align: "center",
            width: 80,
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
        },
        {
            field: "mumid",
            headerName: "MUM ID",
            headerAlign: "center",
            align: "center",
            width: 85,
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: (params) => (!params.value) ? "" : params.value,
        },
        {
            field: "certificateid",
            headerName: "CERT",
            headerAlign: "center",
            align: "center",
            width: 100,
            renderCell: renderCellExpand,
        },
        {
            field: "status",
            headerName: "STATUS",
            headerAlign: "center",
            align: "center",
            width: 80,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.status : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        {
            field: "suratid",
            headerName: "SURATID",
            headerAlign: "center",
            align: "center",
            width: 100,
            renderCell: renderCellExpand,
        },
        {
            field: "createdat",
            headerName: "CREATED AT",
            headerAlign: "center",
            align: "center",
            width: 150,
            type: "dateTime",
            valueGetter: (params) => {
                if (params.value) {
                    return new Date(params.value);
                }
                return null;
            },
            renderCell: (params) => Utility.ConvertUtcToLocalTime(params.value),
        },
        {
            field: "updatedat",
            headerName: "UPDATED AT",
            headerAlign: "center",
            align: "center",
            width: 150,
            type: "dateTime",
            valueGetter: (params) => {
                if (params.value) {
                    return new Date(params.value);
                }
                return null;
            },
            renderCell: (params) => Utility.ConvertUtcToLocalTime(params.value),
        },
        {
            field: "imgstatus",
            headerName: "IMAGE STATUS",
            headerAlign: "center",
            align: "center",
            width: 220,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.imgstatus : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
            cellClassName: (params) => params.value === "" || (params.value && params.value.includes("DONE")) ? null : "redColor"
        },
        {
            field: "vidstatus",
            headerName: "VIDEO STATUS",
            headerAlign: "center",
            align: "center",
            width: 200,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.vidstatus : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
            cellClassName: (params) => params.value === "" || (params.value && params.value.includes("DONE")) ? null : "redColor"
        },
        {
            field: "certstatus",
            headerName: "CERTIFICATE STATUS",
            headerAlign: "center",
            align: "center",
            width: 200,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.certstatus : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
            cellClassName: (params) => params.value === "" || (params.value && params.value.includes("DONE")) ? null : "redColor"
        },
        {
            field: "mp4status",
            headerName: "MP4 STATUS",
            headerAlign: "center",
            align: "center",
            width: 200,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.mp4status : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
            cellClassName: (params) => params.value === "" || (params.value && params.value.includes("DONE")) ? null : "redColor"
        },
        {
            field: "jsonstatus",
            headerName: "JSON STATUS",
            headerAlign: "center",
            align: "center",
            width: 200,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.jsonstatus : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
            cellClassName: (params) => params.value === "" || (params.value && params.value.includes("DONE")) ? null : "redColor"
        },
        {
            field: "age",
            headerName: "AGE",
            headerAlign: "center",
            align: "center",
            type: "number",
            width: 50,
            valueFormatter: (params) => params.value,
            valueGetter: (params) => {
                if (params.value)
                    return Utility.ConvertDateToAge(params.value);
                else
                    return null;
            },
            renderCell: (params) => {
                return params.value;
            },
        },
        {
            field: "media",
            headerName: "MEDIA",
            headerAlign: "center",
            align: "center",
            width: 55,
            renderCell: (params) => (
                <Tooltip title={"Stone Media"} sx={{ cursor: "pointer" }}>
                    <VideoLibraryTwoToneIcon
                        sx={{ cursor: "pointer" }}
                        onClick={() => {
                            setStoneMediaURL(params.row.stonemediaurl);
                            setShowStoneMediaModal(true);
                        }} />
                </Tooltip>
            ),
        }
    ];

    const rows = stockData;
    // const columns = columnNames;

    const allowed = Utility.isReadAllowed(mediaTransferPermission);
    function CustomToolbar({ force, setForce }) {
        return (
            <GridToolbarContainer
                sx={{
                    display: "flex",
                    alignItems: "center",
                    marginHorizontal: "5px",
                    "&.MuiDataGrid-toolbarContainer": {
                        padding: "0px 4px !important",
                    },
                }}
            >
                <CommonStoneSelection
                    title={"Enter multiple Stone Ids"}
                    handleSelection={handleSelection}
                    bgColor='#454545'
                    buttonDisabled={rows.length === 0} />

                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarExport />
                <Box sx={{ flexGrow: 1, display: { md: "none", lg: "block" } }} />
                {stockLoader ? (
                    <CircularProgress sx={{ cursor: "pointer", width: "1.8rem !important" }} />
                ) : (
                    <Tooltip title="Reload List">
                        <RefreshOutlinedIcon
                            onClick={() => handleSearch()}
                            color="primary"
                            fontSize="large"
                            sx={{ cursor: "pointer", width: "1.8rem" }}
                        />
                    </Tooltip>
                )}
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                    }}
                >
                    <Checkbox
                        onChange={() => setForce(prev => !prev)}
                        checked={force}
                        size="small"
                    />
                    <Typography
                        sx={{
                            fontSize: "13px",
                            fontWeight: 600,
                        }}
                    >
                        Force
                    </Typography>
                </Box>
                <Button
                    color="success"
                    variant="contained"
                    size="small"
                    sx={{ ml: "5px" }}
                    onClick={() => setShowModal(true)}
                    startIcon={<TaskAltIcon size="large" />}
                    disabled={stockLoader}
                >
                    Force Media Transfer
                </Button>
                <GridToolbarQuickFilter debounceMs={500} />
            </GridToolbarContainer>
        )
    }

    return (
        !allowed ? <NoPermission /> :
            <div>
                <Container maxWidth="xxl">

                    {showStoneDetailModal ? (
                        <StoneDetailModal
                            show={showStoneDetailModal}
                            stoneId={stoneId}
                            handleClose={handleClose}
                        />
                    ) : null}

                    <TabMenuSnackbar
                        show={successSnackbar}
                        message={'Stone Updated Successfully'}
                        variant={"success"}
                        autoHide={Constants.SnackBarCloseTimer}
                        title={"Success"}
                        handleClose={() => setSuccessSnackbar(false)}
                    />

                    <TabMenuSnackbar
                        show={errorSnackbar}
                        message={errorMessage !== "" ? errorMessage : Constants.APiFailErrorMessage}
                        variant={"error"}
                        autoHide={Constants.SnackBarCloseTimer}
                        title={"Failed"}
                        handleClose={() => setErrorSnackbar(false)}
                    />

                    {showStoneMediaModal ? (
                        <>
                            <StoneMediaModal
                                show={showStoneMediaModal}
                                stoneMediaURL={stoneMediaURL}
                                handleClose={() => setShowStoneMediaModal(false)}
                            />
                        </>
                    ) : null}
                    <Box
                        m={1}
                        display="flex"
                        flexDirection={{ xs: "column", sm: "row" }}
                        gap={2}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: { xs: "column", sm: "row" },
                                alignItems: "center",
                                gap: "10px",
                                width: { xs: "100%", sm: "auto" },
                            }}
                        >
                            <Typography>Status</Typography>
                            <Box
                                sx={{
                                    flex: 1,
                                    minWidth: "300px",
                                    "& .MuiSelect-select": {
                                        height: "0.5em !important",
                                    },
                                }}
                            >
                                <Select
                                    menuPlacement="auto"
                                    blurInputOnSelect={false}
                                    className="basic-single"
                                    classNamePrefix="select"
                                    value={status}
                                    isSearchable={true}
                                    name="status"
                                    menuPortalTarget={document.body}
                                    styles={Constants.Styles}
                                    options={statusOptions}
                                    isMulti
                                    onChange={(selectedOption) => {
                                        setStatus(selectedOption)
                                    }}
                                />
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: { xs: "column", sm: "row" },
                                alignItems: "center",
                                gap: "10px",
                                width: { xs: "100%", sm: "auto" },
                            }}
                        >
                            <Typography>Stone Status</Typography>
                            <Box
                                sx={{
                                    flex: 1,
                                    minWidth: "300px",
                                    "& .MuiSelect-select": {
                                        height: "0.5em !important",
                                    },
                                }}
                            >
                                <Select
                                    menuPlacement="auto"
                                    blurInputOnSelect={false}
                                    className="basic-single"
                                    classNamePrefix="select"
                                    value={stoneStatus}
                                    isSearchable={true}
                                    name="status"
                                    menuPortalTarget={document.body}
                                    styles={Constants.Styles}
                                    options={stoneStatusOptions}
                                    isMulti
                                    onChange={(selectedOption) => {
                                        setStoneStatus(selectedOption)
                                    }}
                                />
                            </Box>
                        </Box>
                        <Box>
                            <LoadingButton
                                loading={stockLoader}
                                loadingPosition="start"
                                variant="contained"
                                onClick={() => handleSearch()}
                                startIcon={<SearchOutlinedIcon size="large" />}
                                disabled={status.length === 0 || stoneStatus.length === 0}
                            >
                                Search
                            </LoadingButton>
                        </Box>
                    </Box>
                    <Box
                        sx={{
                            backgroundColor: '#fff',
                            color: '#000',
                            width: "100%",
                            position: "relative",
                            "& .MuiTablePagination-selectLabel": {
                                marginTop: "15px",
                            },
                            "& .MuiTablePagination-displayedRows": {
                                marginTop: "15px",
                            },
                            "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                                fontWeight: Constants.defaultFontWeight,
                            },
                            "& .css-cc8tf1": {
                                fontWeight: Constants.defaultFontWeight,
                            },
                            height: '80vh',
                            "& .lavenderCell": {
                                color: "#080808",
                                backgroundColor: "#D8BFD8",
                            },
                            "& .redColor": {
                                backgroundColor: "#f5d7d7"
                            }
                        }}
                    >
                        <StyledDataGrid
                            disableRowSelectionOnClick={true}
                            localeText={{ noRowsLabel: "No Record Found" }}
                            sx={{ height: "80vh", fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight, }}
                            slots={{
                                toolbar: CustomToolbar,
                            }}
                            rows={rows}
                            style={{}}
                            sortModel={sortModel}
                            onSortModelChange={(newModel) => setSortModel(newModel)}
                            density="compact"
                            columns={columns}
                            getRowId={(row) => row.stoneid}
                            checkboxSelection={true}
                            onRowSelectionModelChange={(newSelectionModel) => {
                                setSelectionModel(newSelectionModel);
                            }}
                            loading={stockLoader}
                            rowSelectionModel={selectionModel}
                            onColumnOrderChange={(params) => Utility.handleColumnOrderChange(params, columns, setColumns, window.location.pathname)}
                            initialState={{
                                columns: {
                                    columnVisibilityModel: {
                                        // Hide columns id, the other columns will remain visible
                                        status: false,
                                        mumid: false,
                                        createdat: false,
                                        updatedat: false,
                                    },
                                },
                                pagination: {
                                    paginationModel: Constants.pageSize,
                                },
                            }}
                            pageSizeOptions={Constants.pageSizeOptions}
                            pagination
                            slotProps={{
                                toolbar: {
                                    force, setForce
                                },
                            }}
                        />
                    </Box>

                    {showModal ? (
                        <Modal
                            show={showModal}
                            onHide={handleClose}
                            backdrop="static"
                            keyboard={true}
                            size="lg"
                            enforceFocus={false}
                            centered
                        >
                            <Modal.Header closeButton>
                                <Modal.Title>
                                    <img
                                        src={logo}
                                        height="40pt"
                                        width="40pt"
                                        alt={Constants.COMPANY_SITE}
                                    />
                                    &nbsp;&nbsp;Add Stone Ids
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Form.Label className="mt-2">
                                    Stone ID: <sup style={{ color: "red" }}>*</sup>
                                </Form.Label>
                                <TextField
                                    id="outlined-multiline-static"
                                    label="Comma seperated Certificate Ids (required)"
                                    multiline
                                    fullWidth
                                    rows={4}
                                    value={stoneIds}
                                    onChange={(e) =>
                                        setStoneIds(Utility.ConvertNewLineToComma(e.target.value))
                                    }
                                />
                            </Modal.Body>
                            <Modal.Footer>
                                <Box sx={{
                                    "& .Mui-disabled": {
                                        backgroundColor: "rgba(0, 0, 0, 0.12) !important",
                                        color: "rgba(0, 0, 0, 0.26) !important"
                                    }
                                }}>
                                    <LoadingButton
                                        loading={loadingButton}
                                        loadingPosition="start"
                                        startIcon={<SaveIcon />}
                                        variant="contained"
                                        sx={{ mr: 2 }}
                                        onClick={saveHandler}
                                        type="Submit"
                                        disabled={stoneIds === ""}
                                    >
                                        Save
                                    </LoadingButton>
                                </Box>
                                <Button disabled={loadingButton} variant="contained" color="error" onClick={handleClose}>
                                    Close
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    ) : null}

                </Container>
            </div >
    );
}